(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-color-swatches"] && !Shopify.designMode) return;
  try {
    class ProductColorSwatches extends HTMLElement {
  /** @type {AbortController | null} */
  #abort = null;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    this.addEventListener('change', this.#onChange, { signal });

    const section = this.closest('.shopify-section');
    section?.addEventListener('variant:update', this.#syncFromPicker, { signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#abort = null;
  }

  /**
   * @param {Event} event
   */
  #onChange = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;

    this.#setValueLabel(target.value);
    this.#applyVariantId(target.dataset.variantId);

    const picker = this.closest('.shopify-section')?.querySelector('variant-picker');
    const match = picker?.querySelector(`input[data-option-value-id="${target.dataset.optionValueId}"]`);
    if (!(match instanceof HTMLInputElement)) return;

    if (match.dataset.variantId) this.#applyVariantId(match.dataset.variantId);
    if (match.checked) return;

    match.checked = true;
    match.dispatchEvent(new Event('change', { bubbles: true }));
  };

  #syncFromPicker = () => {
    const picker = this.closest('.shopify-section')?.querySelector('variant-picker');
    if (!picker) return;

    this.querySelectorAll('.product-color-swatches__input').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const source = picker.querySelector(`input[data-option-value-id="${input.dataset.optionValueId}"]`);
      if (source instanceof HTMLInputElement) {
        input.checked = source.checked;
        if (source.dataset.variantId) input.dataset.variantId = source.dataset.variantId;
      }
      if (input.checked) {
        this.#setValueLabel(input.value);
        this.#applyVariantId(input.dataset.variantId);
      }
    });
  };

  /**
   * @param {string | undefined} variantId
   */
  #applyVariantId(variantId) {
    if (!variantId) return;

    this.closest('.shopify-section')
      ?.querySelectorAll('product-form-component input[name="id"]')
      .forEach((input) => {
        if (input instanceof HTMLInputElement) input.value = variantId;
      });
  };

  /**
   * @param {string} value
   */
  #setValueLabel(value) {
    const label = this.querySelector('[data-color-value]');
    if (label) label.textContent = value;
  }
}

if (!customElements.get('product-color-swatches')) {
  customElements.define('product-color-swatches', ProductColorSwatches);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-delivery-estimate"] && !Shopify.designMode) return;
  try {
    class ProductDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const targets = this.querySelectorAll('[data-delivery-template]');
    if (!targets.length) return;

    const minDays = Number(this.dataset.minDays || 3);
    const maxDays = Math.max(minDays, Number(this.dataset.maxDays || 5));
    const skipWeekends = this.dataset.skipWeekends === 'true';
    const cutoffHour = Number(this.dataset.cutoffHour || 14);
    const dateFormat = this.dataset.dateFormat || 'long';
    const locale = this.dataset.locale || 'fr';

    const start = new Date();
    start.setHours(0, 0, 0, 0);
    if (new Date().getHours() >= cutoffHour) {
      start.setDate(start.getDate() + 1);
    }

    const minDate = this.#addDays(start, minDays, skipWeekends);
    const maxDate = this.#addDays(start, maxDays, skipWeekends);

    const format = (date) => {
      if (dateFormat === 'short') {
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        return `${dd}/${mm}`;
      }
      return date.toLocaleDateString(locale, { day: 'numeric', month: 'long' });
    };

    targets.forEach((el) => {
      const template = el.dataset.deliveryTemplate;
      if (!template || !/\[DATE_(MIN|MAX)\]/.test(template)) return;

      el.textContent = template
        .replace(/\[DATE_MIN\]/g, format(minDate))
        .replace(/\[DATE_MAX\]/g, format(maxDate))
        .replace(/\[JOURS_MIN\]/g, String(minDays))
        .replace(/\[JOURS_MAX\]/g, String(maxDays));
    });
  }

  /**
   * @param {Date} from
   * @param {number} days
   * @param {boolean} skipWeekends
   */
  #addDays(from, days, skipWeekends) {
    const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;

    while (added < days) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (skipWeekends && (weekday === 0 || weekday === 6)) continue;
      added += 1;
    }

    return date;
  }
}

if (!customElements.get('product-delivery-estimate')) {
  customElements.define('product-delivery-estimate', ProductDeliveryEstimate);
}
  } catch(e) { console.error(e); }
})();

})();
